/*
@function calculateSchoolsScore
@param {Object} listing
@param {String} filterValue
*/
function calculateSchoolsScore(listing, filterValue) {
    var weight;
    var value = listing.reports.schools.score / 10;
    var threshold;
    var metWhyWhyNotThreshold;

    if(filterValue === 'very') {
        weight = 1;
        threshold = 6;
    } else if(filterValue === 'somewhat') {
        weight = 0.5;
        threshold = 2;
    } else if(filterValue === 'not so much') {
        weight = 0.1;
        threshold = -1000000; // Basically no threshold allow all to pass
    }

    if(filterValue === 'not so much') {
        metWhyWhyNotThreshold = 'neutral';
    } else if(value >= 8) {
        metWhyWhyNotThreshold = true;
    } else if(value <= 3) {
        metWhyWhyNotThreshold = false;
    } else {
        metWhyWhyNotThreshold = 'neutral';
    }

    return {
        weight: weight,
        value: value,
        score: value * weight,
        metThreshold: (value * weight) >= threshold,
        metWhyWhyNotThreshold: metWhyWhyNotThreshold
    };
}

module.exports = calculateSchoolsScore;
